/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionCustomerGranteesCountriesQuery = gql`
  query GetSouscriptionCustomerGranteesCountriesQuery($search: String) {
    getSouscriptionCustomerGranteesCountries_souscription_customer_grantees(search: $search) {
      countries {
 value  
label  
}
    }
  }
`;

export default GetSouscriptionCustomerGranteesCountriesQuery;
